import { initializeApp } from 'firebase/app';
import { getDatabase, ref, set, onValue } from 'firebase/database';
import { getAnalytics } from 'firebase/analytics';
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  getDoc,
} from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAB4T3ANTUbT_X_0hB-pthTJ5l3OK5pbWs',
  authDomain: 'takip-app-2a94f.firebaseapp.com',
  databaseURL: 'https://takip-app-2a94f-default-rtdb.firebaseio.com',
  projectId: 'takip-app-2a94f',
  storageBucket: 'takip-app-2a94f.appspot.com',
  messagingSenderId: '858626453295',
  appId: '1:858626453295:web:864f377ce27adb41ed3bda',
  measurementId: 'G-7J87R33DBX',
};

const app = initializeApp(firebaseConfig);

const db = getDatabase(app); // Realtime Database
const firestore = getFirestore(app); // Firestore

const analytics = getAnalytics(app);

export {
  db,
  ref,
  set,
  onValue,
  firestore, // Burada Firestore'u export et
  collection,
  getDocs,
  doc,
  getDoc,
  analytics,
};
